import {MolecularGraph} from "../../graph/MolecularGraph"
import {ringExtractor} from "./ringExtractor";
import {chainExtractor} from "./chainExtractor";

export const structuralFeatureExtractor = {
    extract: (graph: MolecularGraph) => {
        const features = [
            ...ringExtractor.extract(graph),
            ...chainExtractor.extract(graph, {onlyCarbonChains: true})
        ]

        return features;
    }
}
